import { ContentPageSectionModel } from '../model/contentPageSectionModel';
import { BrokerAuditDataModel } from '../model/brokerAuditDataModel';
import { BadQuestionnaireModel } from '../model/badQuestionnaireModel';
import { WorkflowModel } from '../model/workflowModel';
import { CompleteFunctionResponseModel } from '../model/completeFunctionResponseModel';
import { ContentPageListItemModel } from '../model/contentPageListItemModel';
import { ContentPageListModel } from '../model/contentPageListModel';
import { BadSectionModel } from '../model/badSectionModel';
import { BadQuestionModel } from '../model/badQuestionModel';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { Injectable } from '@angular/core';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable()
export class PdfStream{ 
  stepContent: ContentPageSectionModel;
  numUnlicensed: number =0;
  leaseSalesTransactions: number =0;
 
  constructor(){

  }
  public makePdf(baDataModel: BrokerAuditDataModel, badQuestionModel: BadQuestionnaireModel, workFlow: WorkflowModel,
    completeFunction: CompleteFunctionResponseModel,badAffiramation1:boolean,badAffiramation2:boolean) {
  
    
    this.stepContent = workFlow.Steps[0].StepMessage.Sections[1];

   

    const documentDefinition = {

      header: function () {
        return [{
          columns: [
            { text: new Date().getMonth()+1 + '/' + new Date().getDate() + '/' + new Date().getFullYear(), margin: [15, 5, 0, 0] },
            { text: 'Broker Audit Declaration', alignment: 'right', margin: [0, 5, 15, 0] }
          ]
        }]
      },

      content: [
        {
          text: 'Broker Audit Declaration',
          bold: true,
          fontSize: 20,
          alignment: 'center',
          margin: [0, 0, 0, 5],
          color: '#066'
        },
        this.allSectionsInfo(this.stepContent),
        {
          text: 'Miscellaneous Information',
          style: 'title'
        },
        {
          text: [            
            { text:  'Is this a Home Office? :   '},           
            { text: baDataModel.HomeOffice == undefined || baDataModel.HomeOffice==false ? 'N' : 'Y'}
          ],
          margin: [20, 5, 0, 0]
        },
        {
          text: [            
            { text:  'Number of salespersons and associate brokers licensed to the brokerage: '},           
            { text: baDataModel.NumLicensedEmployees == undefined ? '0' : baDataModel.NumLicensedEmployees},
            { text:'\n Do not include the Designated Broker. ', margin:[40,0,0,0],color:'#777777'}
          ],      
          margin: [20, 2, 0, 0]
        },
        {
            text: [            
              { text:  'Number of associate brokers with delegated broker duties: '},           
              { text: baDataModel.NumAssociateBrokersDelegatedBrokerDuties == undefined ? '0' : baDataModel.NumAssociateBrokersDelegatedBrokerDuties}
            ],      
            margin: [20, 2, 0, 0]
        },
        {
            text: [            
              { text:  'Number of unlicensed full-time employees employed by the brokerage: '},           
              { text: baDataModel.NumUnlicensedFullTimeEmployees == undefined ? '0' : baDataModel.NumUnlicensedFullTimeEmployees}
            ],      
            margin: [20, 2, 0, 0]
        },
        {
            text: [            
              { text:  'Number of unlicensed part-time employees employed by the brokerage: '},           
              { text: baDataModel.NumUnlicensedPartTimeEmployees == undefined ? '0' : baDataModel.NumUnlicensedPartTimeEmployees}
            ],      
            margin: [20, 2, 0, 0]
        },
        {
            text: [            
              { text:  'Number of real estate teams associated with the brokerage: '},           
              { text: baDataModel.NumRealEstateTeams == undefined ? '0' : baDataModel.NumRealEstateTeams}
            ],      
            margin: [20, 2, 0, 0]
        },
        {
            text: [            
              { text:  'Average number of Sales transactions handled per year: '},           
              { text: baDataModel.NumSalesTransactions == undefined ? '0' : baDataModel.NumSalesTransactions}
            ],      
            margin: [20, 2, 0, 0]
        },
        {
            text: [            
              { text:  'Average number of Residential Lease transactions handled per year: '},           
              { text: baDataModel.NumResidentialLeaseTransactions == undefined ? '0' : baDataModel.NumResidentialLeaseTransactions}
            ],      
            margin: [20, 2, 0, 0]
        },
        {
            text: [            
              { text:  'Average number of Commercial Lease transactions handled per year: '},           
              { text: baDataModel.NumCommercialLeaseTransactions == undefined ? '0' : baDataModel.NumCommercialLeaseTransactions}
            ],      
            margin: [20, 2, 0, 0]
        },
      
       
     
        {
          text: [            
            { text:  'The broker maintains one or more general (escrow) trust accounts: ' },           
            { text: baDataModel.MaintainsGeneralTrustAccounts == undefined || baDataModel.MaintainsGeneralTrustAccounts==false ? 'N' : 'Y'},
            { text:'\n Do not include property management trust accounts. ', margin:[40,0,0,0],color:'#777777'}
          ], 
          margin: [20, 2, 0, 0]
        },
        {
            text: [            
              { text:  'The broker maintains one or more property management trust accounts:   '},           
              { text: baDataModel.MaintainsPropertyManagementTrustAccounts == undefined || baDataModel.MaintainsPropertyManagementTrustAccounts==false ? 'N' : 'Y'}
            ],
            margin: [20, 5, 0, 0]
          },
          {
            text: [            
              { text:  'The broker utilizes one or more off-site storage locations:   '},           
              { text: baDataModel.UtilizesOffSiteStorageLocations == undefined || baDataModel.UtilizesOffSiteStorageLocations==false ? 'N' : 'Y'}
            ],
            margin: [20, 5, 0, 0]
          },
          {
            text: [            
              { text:  'The broker utilizes one or more transaction management systems:   '},           
              { text: baDataModel.UtilizesTransactionManagementSystems == undefined || baDataModel.UtilizesTransactionManagementSystems==false ? 'N' : 'Y'}
            ],
            margin: [20, 5, 0, 0]
          },
          {
            text: [            
              { text:  'The broker utilizes one or more property management accounting systems:   '},           
              { text: baDataModel.UtilizesPropertyManagementAccountingSystems == undefined || baDataModel.UtilizesPropertyManagementAccountingSystems==false ? 'N' : 'Y'}
            ],
            margin: [20, 5, 0, 0]
          },
          {
            text: [            
              { text:  'The broker utilizes one or more electronic storage systems owned by the broker:   '},           
              { text: baDataModel.UtilizesOwnedElectronicStorageSystems == undefined || baDataModel.UtilizesOwnedElectronicStorageSystems==false ? 'N' : 'Y'}
            ],
            margin: [20, 5, 0, 0]
          },
          {
            text: [            
              { text:  'The broker utilizes one or more electronic storage systems not owned by the broker:   '},           
              { text: baDataModel.UtilizesNotOwnedElectronicStorageSystems == undefined || baDataModel.UtilizesNotOwnedElectronicStorageSystems==false ? 'N' : 'Y'}
            ],
            margin: [20, 5, 0, 0]
          },
        

        {
          text: 'The brokerage conducts: \n (check all that apply) : ',
          margin: [20, 2, 0, 0]
        },

        this.buildbrokegeconducts(baDataModel),

        {
          text: [            
            { text:  'If "Other" was selected, then list the other types of business below: ' },           
            { text: baDataModel.OtherText}
          ],
          margin: [20, 2, 0, 0]
        },


        {
          text: 'General/Sales/Earnest Trust Accounts',
          style: 'title'
        },

        this.table4Columns(baDataModel.GeneralTrustAccounts, ['Title', 'FinancialInstitutionName', 'FinanialInstitutionAddress', 'AccountNumber'], ['Trust Account Title', ' Financial Institution Name ', 'Financial Institution Address \n (include street address, City, State, ZIP Code)', 'Account Number']),

        this.section(badQuestionModel.Sections[0]),


        {
          text: 'Property Management Properties',
          style: 'title'
        },

        {
          text: 'Residential',
          style: 'title1'
        },

        {
          text: [            
            { text:  'Number of licensees performing residential property management activities for brokerage: ' },           
            { text: baDataModel.NumLicenseesResidentialPropertyManagement == undefined ? 0 : baDataModel.NumLicenseesResidentialPropertyManagement}
          ],         
          margin: [30, 2, 0, 0]
        },
        {
          text: [            
            { text:  'Single Family Residences: ' },           
            { text: baDataModel.NumSingleFamilyHomes == undefined ? 0 : baDataModel.NumSingleFamilyHomes}
          ],         
          margin: [30, 2, 0, 0]
        },
        {
          text: [            
            { text:  'Multi Family Units:    ' },           
            { text: baDataModel.NumMultiFamilyUnits == undefined ? 0 : baDataModel.NumMultiFamilyUnits}
          ],
          margin: [30, 2, 0, 0]
        },
        {
          text: [            
            { text:  'Doors:    ' },           
            { text: baDataModel.NumMultiFamilyDoors == undefined ? 0 : baDataModel.NumMultiFamilyDoors}
          ],
          margin: [30, 2, 0, 0]
        },
        {
          text: [            
            { text:  'Other:    ' },           
            { text: baDataModel.NumOtherResidential == undefined ? 0 : baDataModel.NumOtherResidential},
            { text: baDataModel.OtherResidentialText == undefined ? 0 : '\n'+baDataModel.OtherResidentialText}
          ],
          margin: [30, 2, 0, 0]
        },


        {
          text: 'Commercial',
          style: 'title1'
        },

        {
          text: [            
            { text:  'Number of licensees performing commercial property management activities for brokerage:    '},           
            { text: baDataModel.NumLicenseesCommercialPropertyManagement == undefined ? 0 : baDataModel.NumLicenseesCommercialPropertyManagement}
          ],
          margin: [30, 2, 0, 0]
        },
        {
          text: [            
            { text:  'Shopping Centers:    '},           
            { text: baDataModel.NumShoppingCenters == undefined ? 0 : baDataModel.NumShoppingCenters}
          ],
          margin: [30, 2, 0, 0]
        },
        {
          text: [            
            { text:  'Commercial/Industrial Buildings:    '},           
            { text: baDataModel.NumCommercialBuildings == undefined ? 0 : baDataModel.NumCommercialBuildings}
          ],
          margin: [30, 2, 0, 0]
        },
        {
          text: [            
            { text:  'Other:    ' },           
            { text: baDataModel.NumOtherCommercial == undefined ? 0 : baDataModel.NumOtherCommercial},
            { text: baDataModel.OtherCommercialText == undefined ? 0 : '\n'+baDataModel.OtherCommercialText}
          ],
          margin: [30, 2, 0, 0]
        },

        this.section(badQuestionModel.Sections[13]),

        {
          text: 'Property Management Trust Accounts',
          style: 'title'
        },
        this.table4Columns(baDataModel.PropertyManagementTrustAccounts, ['Title', 'FinancialInstitutionName', 'FinanialInstitutionAddress', 'AccountNumber'], ['Trust Account Title', ' Financial Institution Name ', 'Financial Institution Address \n (include street address, City, State, ZIP Code)', 'Account Number']),
  
        {
          text: 'Off-Site Storage Locations',
          style: 'title'
        },
        this.table2Columns(baDataModel.OffSiteStorageLocations, ['FacilityName', 'FacilityAddress'], ['Name of Storage Facility',  'Address']),

        {
          text: 'Transaction Management Systems',
          style: 'title'
        },
        this.table3Columns(baDataModel.TransactionManagementSystems, ['SystemName', 'ProviderAddress','DatesUsed'], ['System Name',  'System Provider Address', 'Dates Used']),

        {
          text: 'Property Management Accounting Systems',
          style: 'title'
        },
        this.table3Columns(baDataModel.PropertyManagementAccountingSystems, ['SystemName', 'ProviderAddress','DatesUsed'], ['System Name',  'System Provider Address', 'Dates Used']),


        {
          text: 'Electronic Storage Systems Broker Owned',
          style: 'title'
        },
        this.table2Columns(baDataModel.BrokerOwnedElectronicStorageSystems, ['StorageType','Location'], ['Type',  'Location']),

        {
          text: 'Electronic Storage Systems Not Broker Owned',
          style: 'title'
        },
        this.table2Columns(baDataModel.NotBrokerOwnedElectronicStorageSystems, ['SystemName','VendorContact'], ['System Name',  'Vendor Point of Contact']),

        
        
        
        this.allSections(badQuestionModel.Sections),

        {
          text: 'Additional Information',
          style: 'title'
        },

        {
          text: [            
            { text:  'Comments: ' },           
            { text: badQuestionModel.AdditionalInformationComments }
          ]
       
        },


        {
          text: 'Audit Declaration Affirmation',
          style: 'title'
        },

        this.buildAuditDeclarationAffirmation(badAffiramation1,badAffiramation2),

        {
          text: 'Transaction Information',
          style: 'title'
        },

        {
         text: 'Your confirmation number is '+completeFunction.ConfirmationNumber
        },
        {
          text: 'Processed date is '+  this.formatTransationDate(new Date())
        }


      ],
      styles: {
        title1:{
          color: '#006699',
          fontSize: 12,
          decoration: 'underline',
          margin: [25, 10, 0, 0]
        },
        title: {
          color: '#006699',
          bold: true,
          fontSize: 12,
          margin: [0, 20, 0, 0]
        },
        tableExample: {
          margin: [0, 5, 0, 15],
          width: 'auto'
        }
      },

      footer: function (currentPage, pageCount) {
        return [{ text: currentPage.toString() + '/' + pageCount, alignment: 'right', margin: [0, 0, 15, 0] }]
      }

    };

    return documentDefinition;
 
  }

 
   formatTransationDate(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var year = date.getFullYear();
    var day = date.getDate();
    var month = date.getMonth(); 
    var seconds = date.getSeconds();
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];      
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    
    var dayString =day < 10 ? '0'+day : day;   
    minutes = minutes < 10 ? '0'+minutes : minutes;
    seconds = seconds <10 ? '0'+seconds : seconds;
    var strTime = months[month]+' '+dayString+', '+year+' '+hours + ':' + minutes + ':' + seconds +' '+ ampm;  
    return strTime;
  }


  

  buildAuditDeclarationAffirmation(affirmation1: boolean , affiramation2:boolean){
    return [
      {
        table: {
          margin: [20, 5, 0, 15],
          widths: [10, '*'],
          body: this.auditDeclarationAffirmation(affirmation1 , affiramation2)
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 15]
      }];
  }
  auditDeclarationAffirmation(affirmation1: boolean , affiramation2:boolean){
    var body =[];

    var affirmationRow1 = [];
    this.checkBoxImage(affirmationRow1,affirmation1);
    affirmationRow1.push('As the Designated Broker, I have personally completed or personally overseen the completion of this Audit Declaration and have personally reviewed and verified the responses in the Audit Declaration. I understand the importance of the broker’s duty to exercise reasonable supervision and control in assuring broker compliance with the law and have made diligent efforts to comply in every respect.');
    body.push(affirmationRow1);

    var affirmationRow2 = [];
    this.checkBoxImage(affirmationRow2,affiramation2);
    affirmationRow2.push('I hereby declare and affirm all responses are true, full, complete and accurate to the best of my knowledge. I further understand that any false, misleading or incomplete answers to this Audit Declaration may be construed as a violation of A.R.S. §32-2153 (A)(3), (A)(17), (A)(21), (A)(22) and/or (B)(8).');
    body.push(affirmationRow2);

    return body;

  }

  buildbrokegeconducts(brokerAuditDataModel: BrokerAuditDataModel) {
    return [
      {
        table: {
          margin: [20, 5, 0, 15],
          widths: [10, '*'],
          body: this.brokegeconducts(brokerAuditDataModel)
        },
        layout: 'noBorders',
        margin: [20, 5, 0, 15]
      }];
  }

  checkBoxImage(row, value: boolean) {
    if (value == undefined || value == false) {
      row.push([
        {
          image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAkSURBVChTY0hLS/tPCgZrOHXqFFEYRQMxYFQDMYCOGojHaf8BgyvjH43Up5UAAAAASUVORK5CYII=',
        }]
      );
    } else {
      row.push([
        {
          image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAABRSURBVChTlYsBCgAxCMN8rY/1UxuV68GcQhcoA5eYu6+XZRAR0o5AQQ7MLF8pgDwG/CCU4YA2YFRlcAV5+MQqgysAjKoM2gB0MhiDiT/Q52sDcuesvKWfLnYAAAAASUVORK5CYII=',
        }]
      );
    }
  }

  brokegeconducts(brokerAuditDataModel: BrokerAuditDataModel) {
    var body = [];
    var residentialRealEstateRow = [];
    this.checkBoxImage(residentialRealEstateRow, brokerAuditDataModel.ResidentialRealEstate);
    residentialRealEstateRow.push('Residential Real Estate');
    body.push(residentialRealEstateRow);

    var commercialSalesRow = [];
    this.checkBoxImage(commercialSalesRow, brokerAuditDataModel.CommercialSales);
    commercialSalesRow.push('Commercial Sales and Leasing');
    body.push(commercialSalesRow);

    var referralBrokerageRow = [];
    this.checkBoxImage(referralBrokerageRow, brokerAuditDataModel.ReferralBrokerage);
    referralBrokerageRow.push('Referral Brokerage ');
    body.push(referralBrokerageRow);

    var businessBrokerageRow = [];
    this.checkBoxImage(businessBrokerageRow, brokerAuditDataModel.BusinessBrokerage);
    businessBrokerageRow.push('Business Brokerage');
    body.push(businessBrokerageRow);

    var farmAndRanchRow = [];
    this.checkBoxImage(farmAndRanchRow, brokerAuditDataModel.FarmAndRanch);
    farmAndRanchRow.push('Farm and Ranch');
    body.push(farmAndRanchRow);

    var residentialPropMgmtRow = [];
    this.checkBoxImage(residentialPropMgmtRow, brokerAuditDataModel.ResidentialPropMgmt);
    residentialPropMgmtRow.push('Residential Property Management');
    body.push(residentialPropMgmtRow);

    var commercialPropMgmtRow = [];
    this.checkBoxImage(commercialPropMgmtRow, brokerAuditDataModel.CommercialPropMgmt);
    commercialPropMgmtRow.push('Commercial Property Management ');
    body.push(commercialPropMgmtRow);

    var newHomeSubdivisionRow = [];
    this.checkBoxImage(newHomeSubdivisionRow, brokerAuditDataModel.NewHomeSubdivision);
    newHomeSubdivisionRow.push('New Home Subdivision');
    body.push(newHomeSubdivisionRow);

    var otherSubdivisionRow = [];
    this.checkBoxImage(otherSubdivisionRow, brokerAuditDataModel.OtherSubdivision);
    otherSubdivisionRow.push('Other Subdivision/Unsubdivided Land ');
    body.push(otherSubdivisionRow);

    var timeshareRow = [];
    this.checkBoxImage(timeshareRow, brokerAuditDataModel.Timeshare);
    timeshareRow.push('Timeshare');
    body.push(timeshareRow);

    var otherRow = [];
    this.checkBoxImage(otherRow, brokerAuditDataModel.Other);
    otherRow.push('Other');
    body.push(otherRow);


    return body;
  }



  sectionInfo(contentPageListItemModel: ContentPageListItemModel[]) {
    var body = [];
    contentPageListItemModel.forEach(function (row) {
      var dataRow = [];
      dataRow.push(row.DefinitionListItem.Name+':');
      dataRow.push(row.DefinitionListItem.Value);
      body.push(dataRow);
    });
    return body;
  }

  buildSectionInfo(contentPageListModel: ContentPageListModel) {
    return [
      {
        text: contentPageListModel.Title.StringContent,
        style: 'title'
      },
      {
        table: {
          widths: ['auto', 'auto'],
          body: this.sectionInfo(contentPageListModel.List)
        },
        layout: 'noBorders',
        margin: [30, 5, 0, 15],
      }];
  }

  allSectionsInfo(stepMessageContent: ContentPageSectionModel) {
    var ret = [];
    stepMessageContent.Lists.forEach(element => {
      ret.push(this.buildSectionInfo(element));
    });
    return ret;
  }


  allSections(sections: BadSectionModel[]) {
    var ret = [];
    sections.forEach(element => {
      if (element.SectionID != 2 && element.SectionID != 16)
        ret.push(this.section(element));
    });
    return ret;
  }

  section(section: BadSectionModel) {
    return [
      {
        text: section.SectionName,
        style: 'title'
      },
      {
        text: section.SectionDescription!=undefined ? section.SectionDescription : ''
      },
      {
        table: {
          margin: [0, 5, 0, 15],
          widths: [30, '*'],
          body: this.buildSectionBody(section.Questions)
        },
        layout: 'noBorders'

      }];
  }


  buildSectionBody(questions: BadQuestionModel[]) {
    var body = [];
    questions.forEach(function (row) {
      var dataRow = [];
      if (row.Answer == undefined)
        dataRow.push('N/A');
      else {
        switch (row.Answer.AnswerTypeID) {
          case 1:
            dataRow.push('Yes');
            break;
          case 2:
            dataRow.push('No');
            break;
          case 3:
            dataRow.push('N/A');
            break;

          default:
            dataRow.push('N/A');
            break;
        }
      }
      dataRow.push([
        {
          text: [
            row.QuestionText + '\n',
            { text: row.CitationText , italics: true, color: '#006699' },
            {text: '\n'},
            { text: row.Answer.Explanation, color: 'red' }]
        }]);
      body.push(dataRow);
    });
    return body;
  }



  buildTableBody(data, columns, columnNames) {
    var body = [];

    body.push(columnNames);

    if (data == undefined || data.length == 0) {
      var dataRow = [];
      for (let index = 0; index < columnNames.length; index++) {
        dataRow.push('None');
      }
      body.push(dataRow);
    }
    else {
      data.forEach(function (row) {
        var dataRow = [];      
       
       columns.forEach(function (column) {
        
          dataRow.push(row[column].toString());

         
        })
     
       
     
        body.push(dataRow);
      
      });
    }

    return body;
  }



  table4Columns(data, columns, columnNames) {    
    return [{

      table: {
        margin: [0, 5, 0, 0],
        widths: ['*', '*', 'auto', '*'],
        body: this.buildTableBody(data, columns, columnNames)
      }
    }]  
  }

  

  table2Columns(data, columns, columnNames){
    return [{

      table: {
        margin: [0, 5, 0, 0],
        widths: ['*', '*'],
        body: this.buildTableBody(data, columns, columnNames)
      }
    }]  
  }

  table3Columns(data, columns, columnNames){
    return [{

      table: {
        margin: [0, 5, 0, 0],
        widths: ['*', '*','*'],
        body: this.buildTableBody(data, columns, columnNames)
      }
    }]  

  }

}


// WEBPACK FOOTER //
// ./src/app/shared/pdfStream.ts